"use strict";require('@ebay/skin/details');